import script from "./GameView.vue?vue&type=script&setup=true&lang=js"
export * from "./GameView.vue?vue&type=script&setup=true&lang=js"

import "./GameView.vue?vue&type=style&index=0&id=c28bbb90&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c28bbb90"]])

export default __exports__